import { render, staticRenderFns } from "./pondRenewal.vue?vue&type=template&id=208d5960&scoped=true"
import script from "./pondRenewal.vue?vue&type=script&lang=js"
export * from "./pondRenewal.vue?vue&type=script&lang=js"
import style0 from "./pondRenewal.vue?vue&type=style&index=0&id=208d5960&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d5960",
  null
  
)

export default component.exports